import React from 'react';
import { useSidebar } from '../../context/SidebarContext';

function Footer() {
  const { isSidebarOpen } = useSidebar();

  return (
    <footer
      className={`footer-background text-center transition-all duration-200 ${isSidebarOpen ? 'md:ml-64' : 'ml-0'}`}
    >
      <p>
        ©
        {new Date().getFullYear()}
        {' '}
        Metroenergy. Todos los derechos reservados.
      </p>
    </footer>
  );
}

export default Footer;
